import { intoSequentialPromise } from '@utils/async'

export { default as convertJsonToRows } from './convertJsonToRows'
export { default as convertPasteToJson } from './convertPasteToJson'

export const isPastedSpreadsheet = string => string
  .slice(0, 50)
  .split('\t').length > 2

export default {
  auto: '*',

  store: {
    actions: {
      BUILD_ARTICLE_BLUEPRINTS: ({ dispatch }, articleBlueprintsSchemes) =>
        articleBlueprintsSchemes
          .map(scheme => () =>
            dispatch('CREATE_ARTICLE_BLUEPRINT', { scheme }))
          .reduce(intoSequentialPromise, []),
    },
  },
}
